import { render, staticRenderFns } from "./RegistrationResultView.vue?vue&type=template&id=0a4371e8&scoped=true"
import script from "./RegistrationResultView.vue?vue&type=script&lang=js"
export * from "./RegistrationResultView.vue?vue&type=script&lang=js"
import style0 from "./RegistrationResultView.vue?vue&type=style&index=0&id=0a4371e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4371e8",
  null
  
)

export default component.exports